export const CONTACT_INFO = {
  email: 'techsflow.official@gmail.com',
  phone: '+91 83085 38324',
  phoneClean: 'tel:+918308538324',
  whatsapp: 'https://wa.me/918308538324',
  instagram: 'https://instagram.com/techsflow',
  instagramHandle: '@techsflow',
  location: 'Amravati, Maharashtra IN',
  studioShort: 'Amravati, IN'
};
